module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no-results":"No search results"},"ja":{"no-results":"検索結果なし"}}')
  delete Component.options._Ctor
}
